module.exports = ".fixed-bottom-selector {\n  position: fixed;\n  bottom: 0;\n  right: 0; }\n"